<template>
  <standard-page :key="$route.path" :title="title" :content="filteredContent" />
</template>

<script>
import page from '~/mixins/page'
import {
  getDocumentTextColor,
  getDocumentBackgroundColors
} from '~/util/sanity/document-color'
import sanityQuery from '~/sanity/queries/page'
import StandardPage from '~/components/standard-page.vue'

export default {
  components: {
    StandardPage
  },

  mixins: [page],

  async asyncData({
    route,
    params,
    error,
    query,
    $sanity,
    $sentry,
    store,
    redirect
  }) {
    const slug = params.page
    const previewId = query.preview
    try {
      const page = await $sanity.fetch(sanityQuery(slug, previewId))
      if (!page || Object.keys(page).length === 0) {
        throw new Error('Page not found')
      }
      const colors = {
        backgroundColors: getDocumentBackgroundColors(page),
        textColor: getDocumentTextColor(page)
      }
      store.commit('screen/setPageColors', colors)
      return page
    } catch (e) {
      $sentry.captureException(e)
      return redirect('/404')
    }
  },

  data: () => ({
    title: null,
    content: null,
    nonCBDContent: null,
    nonCBDSite: process.env.nonCBDSite
  }),

  computed: {
    filteredContent() {
      return this.nonCBDSite && this.nonCBDContent
        ? this.nonCBDContent
        : this.content
    }
  }
}
</script>
